export default __webpack_public_path__ + "img/5b23e02ab01d5250cf95260d9833c959.svg";